import WorldMapBackground from '../../assets/background-images/globe-svg.svg';
import AdvantagesGrid from '../../components/advantages-grid/advantages-grid.component';
import InsuranceTypesGrid from '../../components/insurance-types-grid/insurance-types-grid.component';
import PartnersShowcase from '../../components/partners-showcase/partners-showcase.component';
import TripSearcher from '../../components/trip-searcher/trip-searcher.component';
import BlogPostsShowcase from '../../components/blog-posts-showcase/blog-posts-showcase.component';
import FaqGrid from '../../components/faq-grid/faq-grid.component';
import ReviewsSlider from '../../components/reviews-slider/reviews-slider.component';
import WelcomeMessage from '../../components/welcome-message/welcome-message.component';
import InsurancePurchaseTutorial from '../../components/insurance-purchase-tutorial/insurance-purchase-tutorial.component';
import TrustBar from '../../components/trust-bar/trust-bar.component';
import { Box, useTheme } from '@mui/material';

const Home = () => {
  const theme = useTheme();
  return (
    <Box>
      <Box
        sx={{
          backgroundImage: {
            md: `url(${WorldMapBackground})`,
            xs: 'none',
          },
          backgroundSize: '150% auto',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top center',
          width: '100%',
          paddingBottom: `${theme.spacingValues.extralarge}`,
          overflowY: 'visible',
        }}
      >
        <WelcomeMessage />
        <TripSearcher />
        <PartnersShowcase />
        <Box sx={{ mt: { xs: 4, md: 4 } }}>
          <TrustBar />
        </Box>
      </Box>
      <Box
        padding={{
          xs: `${theme.spacingValues.extralarge} ${theme.spacingValues.small} `,
          md: `${theme.spacingValues.extralarge} 0`,
        }}
        bgcolor={theme.palette.grey[50]}
      >
        <InsurancePurchaseTutorial />
      </Box>
      <Box
        padding={`${theme.spacingValues.extralarge} 0`}
        bgcolor={theme.palette.text.primary}
      >
        <AdvantagesGrid />
      </Box>
      <Box
        padding={`${theme.spacingValues.extralarge} 0`}
        bgcolor={theme.palette.grey[50]}
      >
        <InsuranceTypesGrid />
      </Box>
      <Box
        padding={{
          xs: `${theme.spacingValues.extralarge} ${theme.spacingValues.small} `,
          md: `${theme.spacingValues.extralarge} 0`,
        }}
      >
        <BlogPostsShowcase />
      </Box>
      <Box
        padding={`${theme.spacingValues.extralarge} 0`}
        bgcolor={theme.palette.text.primary}
      >
        <ReviewsSlider />
      </Box>
      <Box
        padding={{
          xs: `${theme.spacingValues.extralarge} ${theme.spacingValues.small} `,
          md: `${theme.spacingValues.extralarge} 0`,
        }}
        bgcolor={theme.palette.grey[50]}
      >
        <FaqGrid />
      </Box>
    </Box>
  );
};

export default Home;
